import { useCart } from "@shopify/hydrogen-react";
import { useContext, useState, useEffect } from "react";
import { Button } from "@material-tailwind/react";
import { AuthContext } from "../../../../pages/_app";

export type BuyNowButtonProps = {       
  variantId: string;
  quantity: number;
};

export default function BuyNowButton({
  variantId,
  quantity,
}: BuyNowButtonProps) {
    const { linesAdd, status, checkoutUrl, discountCodesUpdate, cartReady, error } = useCart();
    const { authContext } = useContext(AuthContext);
    const [addingToCart, setAddingToCart] = useState(false);
    const [pendingCheckout, setPendingCheckout] = useState(false);
    
    // React to checkoutUrl changes when we're pending checkout
    useEffect(() => {
        if (pendingCheckout && checkoutUrl && cartReady && status === "idle") {
            console.log("Redirecting to checkout:", checkoutUrl);
            window.location.href = checkoutUrl;
            setPendingCheckout(false); // Reset state
        }
    }, [checkoutUrl, cartReady, pendingCheckout, status]);

    const handleAddToCart = async () => {
        if (!variantId || !quantity) return;

        setAddingToCart(true);

        try {
            await linesAdd([
                {
                    merchandiseId: variantId,
                    quantity: quantity,
                },
            ]);
        } catch (error) {
            console.error(error);
        } finally {
            setAddingToCart(false);
        }
    }

    const handleDiscountCode = async () => {
        const subs = authContext?.subs;
    
        if (subs && subs.length > 0) {
            console.log("Applying discount code");
          // TODO - Discount code
          await discountCodesUpdate(["2NZGBEWEYNYA"]);
        }
      };

    const handleCheckout = async () => {  
        await handleAddToCart();
        await handleDiscountCode();
        
        // Set pending checkout state - useEffect will handle the redirect
        setPendingCheckout(true);
        
        // If checkoutUrl is already available, the useEffect will fire immediately
        if (checkoutUrl && cartReady) {
            console.log("Checkout URL immediately available:", checkoutUrl);
        } else {
            console.log("Waiting for checkout URL to be ready...");
        }
    }

  return (
    <Button
      onClick={handleCheckout}
      disabled={
        addingToCart ||
        pendingCheckout ||
        status === "creating" ||
        status === "updating"
      }
      className={`w-full py-3 ${
        !addingToCart && !pendingCheckout && status !== "creating" && status !== "updating"
          ? "bg-scpb-dark-blue hover:bg-blue-700 rounded-md"
          : "bg-gray-300 cursor-not-allowed rounded-md"
      }`}
    >
      {pendingCheckout ? "Redirecting..." : addingToCart || status === "creating" || status === "updating" ? "Adding..." : "Buy Now"}
    </Button>
  );
}   